import store from '../../../store/store';
import { asyncHandler } from '../async-handler';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import {
  CUSTOM_PROMPTS_API,
  CUSTOM_PROMPT_API,
} from '../../constants/central-api';
import {
  CustomPrompt,
  CustomPromptCreateRequest,
  CustomPromptUpdateRequest,
  CustomPromptResponse,
} from '../../../interfaces/CustomPrompt';

// Get all custom prompts for a shop
export default async function get_custom_prompts_api_call(): Promise<
  CustomPrompt[] | null
> {
  try {
    const shopSlug = store.getState().user?.company?.shop_slug;
    const accessToken = store.getState().auth.authorization.accessToken;
    const sellerToken = accessToken?.sellerToken;

    const requestInfo: RequestInfo = {
      url: CUSTOM_PROMPTS_API(shopSlug),
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: accessToken.type + ' ' + sellerToken,
      },
    };

    const actionType = 'GET_CUSTOM_PROMPTS';
    const customMsg = 'Custom prompts retrieved successfully';

    const res: any = await asyncHandler(
      requestInfo,
      actionType,
      customMsg,
      false
    );

    const response: CustomPromptResponse = res?.data;

    if (res?.actionType === actionType && response?.success === true) {
      return response.data as CustomPrompt[];
    } else {
      return null;
    }
  } catch (exception) {
    console.log('Error during get custom prompts request');
    return null;
  }
}

// Create a new custom prompt
export async function create_custom_prompt_api_call(
  customPromptData: CustomPromptCreateRequest
): Promise<CustomPrompt | null> {
  try {
    const shopSlug = store.getState().user?.company?.shop_slug;
    const accessToken = store.getState().auth.authorization.accessToken;
    const sellerToken = accessToken?.sellerToken;

    const requestInfo: RequestInfo = {
      url: CUSTOM_PROMPTS_API(shopSlug),
      method: 'POST',
      body: JSON.stringify(customPromptData),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: accessToken.type + ' ' + sellerToken,
      },
    };

    const actionType = 'CREATE_CUSTOM_PROMPT';
    const customMsg = 'Custom prompt created successfully';

    const res: any = await asyncHandler(requestInfo, actionType, customMsg);

    const response: CustomPromptResponse = res?.data;

    if (res?.actionType === actionType && response?.success === true) {
      return response.data as CustomPrompt;
    } else {
      return null;
    }
  } catch (exception) {
    console.log('Error during create custom prompt request');
    return null;
  }
}

// Update an existing custom prompt
export async function update_custom_prompt_api_call(
  customPromptId: string,
  customPromptData: CustomPromptUpdateRequest
): Promise<CustomPrompt | null> {
  try {
    const shopSlug = store.getState().user?.company?.shop_slug;
    const accessToken = store.getState().auth.authorization.accessToken;
    const sellerToken = accessToken?.sellerToken;

    const requestInfo: RequestInfo = {
      url: CUSTOM_PROMPT_API(shopSlug, customPromptId),
      method: 'PUT',
      body: JSON.stringify(customPromptData),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: accessToken.type + ' ' + sellerToken,
      },
    };

    const actionType = 'UPDATE_CUSTOM_PROMPT';
    const customMsg = 'Custom prompt updated successfully';

    const res: any = await asyncHandler(requestInfo, actionType, customMsg);

    const response: CustomPromptResponse = res?.data;

    if (res?.actionType === actionType && response?.success === true) {
      return response.data as CustomPrompt;
    } else {
      return null;
    }
  } catch (exception) {
    console.log('Error during update custom prompt request');
    return null;
  }
}

// Delete a custom prompt
export async function delete_custom_prompt_api_call(
  customPromptId: string
): Promise<boolean> {
  try {
    const shopSlug = store.getState().user?.company?.shop_slug;
    const accessToken = store.getState().auth.authorization.accessToken;
    const sellerToken = accessToken?.sellerToken;

    const requestInfo: RequestInfo = {
      url: CUSTOM_PROMPT_API(shopSlug, customPromptId),
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: accessToken.type + ' ' + sellerToken,
      },
    };

    const actionType = 'DELETE_CUSTOM_PROMPT';
    const customMsg = 'Custom prompt deleted successfully';

    const res: any = await asyncHandler(requestInfo, actionType, customMsg);

    const response: CustomPromptResponse = res?.data;

    if (res?.actionType === actionType && response?.success === true) {
      return true;
    } else {
      return false;
    }
  } catch (exception) {
    console.log('Error during delete custom prompt request');
    return false;
  }
}
